// Action Types

export const Types = {
  ADD_FILE_REQUESTED: 'files/ADD_FILE_REQUESTED',
  ADD_FILE_SUCCEEDED: 'files/ADD_FILE_SUCCEEDED',
  ADD_FILE_FAILED: 'files/ADD_FILE_FAILED',
  DELETE_FILE_REQUESTED: 'files/DELETE_FILE_REQUESTED',
  DELETE_FILE_SUCCEEDED: 'files/DELETE_FILE_SUCCEEDED',
  DELETE_FILE_FAILED: 'files/DELETE_FILE_FAILED',
}

// Action Creators

export function addFile(payload) {
  return {
    type: Types.ADD_FILE_REQUESTED,
    payload,
  }
}

export function deleteFile(id) {
  return {
    type: Types.DELETE_FILE_REQUESTED,
    payload: id,
  }
}

// Reducer

const INITIAL_STATE = {
  addFileIsLoading: false,
  addFileError: null,
  addFileSucceeded: false,
  lastFileAdded: null,

  deleteFileIsLoading: false,
  deleteFileError: null,
  deleteFileSuccessId: null,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.ADD_FILE_REQUESTED:
      return {
        ...state,
        addFileIsLoading: true,
      }
    case Types.ADD_FILE_SUCCEEDED:
      return {
        ...state,
        addFileIsLoading: false,
        addFileError: null,
        addFileSucceeded: true,
        lastFileAdded: action.payload,
      }
    case Types.ADD_FILE_FAILED:
      return {
        ...state,
        addFileIsLoading: false,
        addFileError: action.payload,
        addFileSucceeded: false,
        lastFileAdded: null,
      }

    case Types.DELETE_FILE_REQUESTED:
      return {
        ...state,
        deleteFileIsLoading: true,
      }
    case Types.DELETE_FILE_SUCCEEDED:
      return {
        ...state,
        deleteFileIsLoading: false,
        deleteFileError: null,
        deleteFileSuccessId: action.payload,
      }
    case Types.DELETE_FILE_FAILED:
      return {
        ...state,
        deleteFileIsLoading: false,
        deleteFileError: action.payload,
      }

    default:
      return state
  }
}
